/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const CogsIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g>
      <path d="M18.5,13.5 L18.5,11.771 C19.5,11.549 19.903,11.17 20.437,10.682 L21.999,11.55 L23.498,8.952 L21.995,8.086 C22.163,7.326 22.146,6.617 21.992,5.916 L23.484,5.05 L21.97,2.451 L20.436,3.319 C19.903,2.83 19.5,2.452 18.5,2.229 L18.5,0.5 L15.5,0.5 L15.5,2.229 C14.5,2.452 14.097,2.83 13.564,3.319 L12.03,2.451 L10.515,5.049 L12.007,5.915 C11.853,6.617 11.836,7.326 12.004,8.085 L10.501,8.951 L12,11.549 L13.562,10.681 C14.095,11.17 14.499,11.549 15.499,11.77 L15.499,13.5 L18.5,13.5 Z" />
      <path d="M8.5,23.5 L8.5,21.771 C9.5,21.549 9.903,21.17 10.437,20.682 L11.999,21.55 L13.498,18.952 L11.995,18.086 C12.163,17.326 12.146,16.617 11.992,15.916 L13.484,15.05 L11.969,12.452 L10.435,13.32 C9.903,12.83 9.5,12.452 8.5,12.229 L8.5,10.5 L5.5,10.5 L5.5,12.229 C4.5,12.452 4.097,12.83 3.564,13.319 L2.03,12.451 L0.515,15.049 L2.007,15.915 C1.853,16.617 1.836,17.326 2.004,18.085 L0.501,18.951 L2,21.549 L3.562,20.681 C4.097,21.17 4.5,21.549 5.5,21.771 L5.5,23.5 L8.5,23.5 Z" />
      <circle cx="17" cy="7" r="2" />
      <circle cx="7" cy="17" r="2" />
    </g>
  </svg>
);

export default CogsIcon;
